import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-policy-standalone',
    templateUrl: './policy-standalone.component.html',
    styleUrls: ['./policy-standalone.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PolicyStandaloneComponent {

}
